import VueGtm from '@gtm-support/vue2-gtm';

export default {
    install(Vue, { config }) {
        if (!config.statistic?.googleTagManagerId) return;

        Vue.use(VueGtm, { id: config.statistic.googleTagManagerId });
    },
};
